<div class="listing">
  <div class="listing-head">
    <div class="col-project">Project</div>
    <div class="col-status">Status</div>
    <div class="col-progress">Progress</div>
    <div class="col-created">Created</div>
    <div class="col-updated">Updated</div>
    <div class="col-chevron"></div>
  </div>

  @for (round of rounds(); track round.id) {
    @let avatar = iconFor(round);
    @let progress = round.progress ?? 0;
    <div class="listing-row" [class.stale]="loading()" (click)="openRound.emit(round.id)">
      <div class="col-project">
        <span class="row-avatar" [style.background-color]="avatar.color">
          <mat-icon>{{ avatar.icon }}</mat-icon>
        </span>
        <span class="project-name">{{ round.projectName || round.projectId }}</span>
      </div>
      <!-- Clicks in the status column change status, not navigate. -->
      <div class="col-status" (click)="$event.stopPropagation()">
        <fb-status-chip
          [statuses]="statuses"
          [current]="round.status"
          (statusChange)="onStatusChange(round, $event)"
        />
      </div>
      <div class="col-progress">
        <fb-progress-bar [value]="progress" [height]="4" />
        <span class="progress-pct">{{ progress }}%</span>
      </div>
      <div class="col-created">{{ round.createdAt | date: 'yyyy-MM-dd' }}</div>
      <div class="col-updated">{{ round.updatedAt | date: 'yyyy-MM-dd' }}</div>
      <div class="col-chevron"><mat-icon>chevron_right</mat-icon></div>
    </div>
  } @empty {
    @if (loading()) {
      <!-- Placeholder rows while the first page loads, so the list isn't blank. -->
      @for (placeholder of placeholderRows; track placeholder) {
        <div class="listing-row listing-row-placeholder" aria-hidden="true">
          <div class="col-project">
            <span class="row-avatar placeholder-bar"></span>
            <span class="placeholder-bar placeholder-name"></span>
          </div>
          <div><span class="placeholder-bar"></span></div>
          <div><span class="placeholder-bar"></span></div>
          <div><span class="placeholder-bar"></span></div>
          <div><span class="placeholder-bar"></span></div>
          <div></div>
        </div>
      }
      <span class="listing-sr-only" role="status">Loading projects…</span>
    } @else {
      <div class="listing-empty">No projects found</div>
    }
  }
</div>